<template>
    <Page :type="(screenSize!='xs') ? 'white' : 'gray'" :header="content[lang].title" :nopadding="false">
        <template v-slot:body>
            <div class="w-full flex flex-column gap-3">
                <div class="w-full flex">
                    <Transactions 
                        :transactions="transactions" 
                        :loading="loading" 
                        :total="total" 
                        :skip="skip" 
                        :limit="limit"
                        @update:first="updateSkip"/>
                </div>
            </div>
        </template>
    </Page>
</template>

<script>
import Connect from         '@/assets/js/Connect'
import Helper from          '@/assets/js/Helper'
import Page from            '@/components/sides/Page.vue' 
import Transactions from    '@/components/personal/Transactions.vue'
import { mapActions } from  'vuex'
import { useRoute } from    'vue-router'

export default {
    data() {
        return {
            content: {
                ru: {
                    title: 'Транзакции карты'
                },
                en: {
                    title: 'Card Transactions',
                }
            },
            loading: true,
            card_id: null,
            transactions: [],
            limit: 10,
            skip: 0,
            total: 0,
            loading_: false,
        }
    },
    components: {
        Page,
        Transactions
    },
    computed: {
        lang() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        screenSize() { return this.$store.getters.StateScreenSize },
        isDarkTheme() { return this.$store.getters.StateDarkTheme },
    },
    methods: {
        ...mapActions(['SetHeaderTitle', 'SetHeaderBtnLeftFirst', 'SetHeaderBtnLeftSecond', 'SetHeaderBtnRightFirst', 'SetHeaderBtnRightSecond']),
        showMess(severity, summary, detail) {
            this.$toast.add({ severity: severity, summary: summary, detail: detail, life: 3000 });
        },
        copy(text){
            this.helper.copy_clipboard(text)
            this.$toast.add({ severity: 'info', summary: this.content[this.lang].copied, detail: text, life: 1000 })
        },
        get_format_amount(value, currency) {
            return this.helper.format_amount(value, currency, 2)
        },
        updateSkip(val){
            this.skip = val
            this.GetCardTransactions()
        },
        async GetCardTransactions(){
            this.loading = true
            this.transactions = []
            try {
                const cardData = await this.connect.GetUserCardTransactionsById(this.card_id, this.limit, this.skip).then(res=>res)
                if(cardData.result) {
                    this.transactions = cardData.data
                    this.total = cardData.total || 0
                } else {
                    this.showMess('error', 'Ошибка', 'Ошибка загрузки данных')
                }
            } catch (error) {
                this.showMess('error', 'Ошибка', 'Ошибка загрузки данных')
            }
            this.loading = false
        },
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
    async mounted() {
        this.helper.SetTgAppHeadColor('white', this.isDarkTheme)
        this.helper.SetTgAppBackButton(false)
        const route = useRoute()
        try {
            if(route.params.id!='' && this.helper.is_id(route.params.id)){
                this.card_id = route.params.id
                this.GetCardTransactions().then(res=>res)
            }
        } catch (error) {
            this.showMess('error', 'Ошибка', 'Ошибка загрузки данных')
        }

        try {
            this.SetHeaderTitle('')
            this.SetHeaderBtnLeftFirst({
                type: 'link',
                link: '/personal/vcards/',
                icon: 'pi pi-arrow-left',
                class: 'text-xs',
                rounded: true,
                severity: 'secondary',
                visible: true,
            })
            this.SetHeaderBtnLeftSecond({})
            this.SetHeaderBtnRightFirst({
                type: 'link',
                link: '/support/',
                icon: 'pi pi-comments',
                class: 'text-xs',
                rounded: true,
                severity: 'secondary',
                visible: true,
            })
            this.SetHeaderBtnRightSecond({})
        } catch (error) {
            console.error('Error setting header:', error)
        }
    }
}
</script>